import React from "react";
export var EKebebMenuItems;
(function (EKebebMenuItems) {
    EKebebMenuItems["START_SWP"] = "Start SWP";
    EKebebMenuItems["START_STP"] = "Start STP";
    EKebebMenuItems["START_SIP"] = "Start SIP";
    EKebebMenuItems["START_LUMPSUM"] = "Start Lumpsum";
    EKebebMenuItems["SWITCH_FUND"] = "Switch Fund";
    EKebebMenuItems["MODIFY"] = "Modify";
    EKebebMenuItems["PAUSE"] = "Pause";
    EKebebMenuItems["CANCEL_SIP"] = "Cancel SIP";
    EKebebMenuItems["VIEW_MANDATE_CALENDAR"] = "View Mandate Calendar";
    EKebebMenuItems["REDEEM"] = "Redeem";
    EKebebMenuItems["VIEW_DETAILS"] = "View Details";
    EKebebMenuItems["RESEND_CONSENT_REQUEST"] = "Resend Consent Request";
    EKebebMenuItems["RESEND_PAYMENT_LINK"] = "Resend Payment Link";
    EKebebMenuItems["DUPLICATE"] = "Duplicate";
    EKebebMenuItems["CANCEL"] = "Cancel";
    EKebebMenuItems["VIEW_ALL_SIPS"] = "View All SIPs";
    EKebebMenuItems["VIEW_ALL_STPS"] = "View All STPs";
    EKebebMenuItems["VIEW_ALL_SWPS"] = "View All SWPs";
    EKebebMenuItems["PLACE_ORDER_AGAIN"] = "Place Order Again";
    EKebebMenuItems["RESUME"] = "Resume";
    EKebebMenuItems["VIEW_TRANSACTION"] = "View Transactions";
    EKebebMenuItems["EXPLORE_OTHER_FUNDS"] = "Explore Other Funds";
})(EKebebMenuItems || (EKebebMenuItems = {}));
var MutualFundOrderbookContext = React.createContext(null);
export default MutualFundOrderbookContext;
